const Modal = function ({
                            title = "",
                            titleSub = "",
                            content,
                            onAppear,
                            onClosing,
                            onClosed,
                            onFailedLoad,
                            showCloseButton = true,
                            closeOnEscape = true,
                            closeOnClickOutside = true,
                            classes = ""
                        } = {}) {
    const titleSubElm = titleSub
        ?
        `<div class="modal__inner__title__title-sub">${titleSub}</div>`
        : '';
    const titleElm = title
        ?
        `<div class="modal__inner__title title">
                <div class="modal__inner__title__main set-h4">${title}</div>
                ${titleSubElm}
             </div>`
        : '';
    const closeElm = (showCloseButton) ? `
<button class="modal__close" data-modal-close title="Close modal" aria-label="Close modal">
    <svg class="icon" width="100%" height="100%" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"  >
        <path d="M3.827,3.092l3.016,-3.016c0.102,-0.101 0.266,-0.101 0.368,0l0.367,0.367c0.101,0.102 0.101,0.266 0,0.368l-3.016,3.016l3.016,3.016c0.101,0.102 0.101,0.266 0,0.368l-0.367,0.367c-0.102,0.101 -0.266,0.101 -0.368,0l-3.016,-3.016l-3.016,3.016c-0.102,0.101 -0.266,0.101 -0.368,0l-0.367,-0.367c-0.101,-0.102 -0.101,-0.266 0,-0.368l3.016,-3.016l-3.016,-3.016c-0.101,-0.102 -0.101,-0.266 0,-0.368l0.367,-0.367c0.102,-0.101 0.266,-0.101 0.368,0l3.016,3.016Z"/>
    </svg>
</button>
` : ``;
    
    const lastFocusElm = document.createElement("button");
    lastFocusElm.type="button";
    lastFocusElm.classList.add("modal__content__last-button");
    lastFocusElm.innerHTML = `<span class="sr-only">Focusable Element</span>`

    const m = document.createElement("div");
    m.classList.add("modal");
    m.setAttribute('role', 'dialog');

    if (classes) {
        classes.split(" ").forEach(cl => m.classList.add(cl));
    }

    m.innerHTML =
        `<div class="modal__inner">
          ${titleElm}
          ${closeElm}
          <div class="modal__content"></div>
        </div>`;

    document.body.appendChild(m);
    m.querySelector("[data-modal-close]").focus();

    const clickedOutsideEvent = (e) => {
        if (!closeOnClickOutside) {
            return;
        }
        if (e.target === m) {
            this.close();
        }
    }

    const destroy = (silent = false) => {
        m.parentNode.removeChild(m);
        Modal.current = null;
        document.querySelector("html").classList.remove("overflow-hidden");
        document.querySelector("html").classList.remove("overlay");
        document.removeEventListener("click", clickedOutsideEvent);
        if (!silent && typeof onClosed === "function") {
            onClosed();
        }
    };

    const addContent = loadedContent => {
        const container = m.querySelector(".modal__content");
        const hasIframe = loadedContent.querySelectorAll("iframe").length > 0;

        let shiftPressed = false;

        if (typeof loadedContent === "string") {
            container.innerHTML = loadedContent;
        } else {
            container.appendChild(loadedContent);
        }
        
        if(container.querySelector("video")){
            container.querySelector("video").play();
        }

        if(hasIframe){
            container.querySelector("iframe").src+="?&autoplay=1";
            container.querySelector("iframe").tabIndex = 0;
        }
        
        ControlBinders.run(container);

        document.addEventListener("click", clickedOutsideEvent);

        const closers = m.querySelectorAll("[data-modal-close]");

        closers.forEach(closeElm => {
            closeElm.addEventListener("keydown",
                event => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        !closeElm.dataset.modal && this.close();
                        document.querySelector('body').classList.add('keyboard-input');
                    }                });
            closeElm.addEventListener("click",
                () => {
                    !closeElm.dataset.modal && this.close();
                });
        });

        m.classList.add("modal--open");
        document.querySelector("html").classList.add("overflow-hidden");
        document.querySelector("html").classList.add("overlay");

        const focusableElements = `button, a[href], input:not([type='hidden']), select, textarea, [tabindex]:not([tabindex="-1"])`;

        const modalFocusableElements = m.querySelectorAll(focusableElements);
        const firstFocusableItemInModal = modalFocusableElements[0];
        const lastFocusableItemInModal = modalFocusableElements[modalFocusableElements.length - 1];
        

        closers[0].focus();

        container.addEventListener("focus", event => {
            event.preventDefault();
            if (shiftPressed) {
                m.querySelectorAll("[data-modal-close]")[0].focus();
                shiftPressed = false;
            }else{
                firstFocusableItemInModal.focus()
            }
        });

        if(hasIframe){
            //if iframe, inject a focusable element at the end
            container.appendChild(lastFocusElm);
            lastFocusElm.addEventListener("focus", ()=>{
                if(!shiftPressed){
                   m.querySelectorAll("[data-modal-close]")[0].focus();
                }
            })
        }else{
            lastFocusableItemInModal.addEventListener('keydown', event => {
                if (event.key === 'Tab' && !event.shiftKey) {
                    event.preventDefault();
                    m.querySelectorAll("[data-modal-close]")[0].focus();
                }
            });
        }

        m.querySelectorAll("[data-modal-close]")[0].addEventListener('keydown', event => {
                if (event.key === 'Tab' && event.shiftKey) {
                    event.preventDefault();
                }
            }
        );

        if (typeof onAppear === "function") {
            onAppear(container);
        }
    };

    this.close = (forceClose = false) => {
        const continueClose = () => {
            destroy();
            return Promise.resolve();
        }

        if (forceClose || typeof onClosing !== "function") {
            return continueClose();
        }

        return Promise.resolve(onClosing(m.querySelector(".modal__content")))
            .then(result => {
                if (result !== false) {
                    return continueClose();
                }

                return Promise.reject("Aborted modal close");
            });
    }

    if (Modal.current) {
        Modal.current.close(true);
    }

    Modal.current = this;
    this.closeOnEscape = closeOnEscape;

    Promise.resolve(content)
        .then(addContent, e => {
            destroy(true);

            if (typeof onFailedLoad === "function") {
                onFailedLoad(e);
            }
        });
}

document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && Modal.current && Modal.current.closeOnEscape) {
        Modal.current.close();
    }
});

ControlBinders.register("[data-modal]", el => {
    const openModal = () => {
        const modal = new Modal({
            title: el.dataset.modalTitle,
            titleSub: el.dataset.modalTitleSub,
            content: el.dataset.modalMethod === "clone" ?
                document.querySelector(el.dataset.modal).cloneNode(true) :
                fetch(el.dataset.modal).then(response => response.text()),
            showCloseButton: !el.dataset.modalHideClose,
            classes: el.dataset.modalClasses,
            onAppear: container => {
                if (typeof el.dataset.modalOnOpen !== undefined && typeof eval(el.dataset.modalOnOpen) === "function") {
                    return eval(el.dataset.modalOnOpen)(container);
                }
            },
            onClosing: container => {
                if (typeof el.dataset.modalOnClose !== undefined && typeof eval(el.dataset.modalOnClose) === "function") {
                    return eval(el.dataset.modalOnClose)(container);
                }
                el.focus();
                return true;
            }
        });
    };

    if (el.dataset.modalAutoload) {
        openModal();
    }

    el.addEventListener("click", function (event) {
        event.stopPropagation();
        openModal();
    });
});